import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import {CURRENCY_TYPES} from '../../core/constants/actionTypes';

export const currencyReducer = createAsyncReducer(CURRENCY_TYPES.RX_GET_CURRENCIES, []);
